
  'use strict';

  function initRelatedProducts() {
    console.log('[Related Products] Initializing...');

    const sliders = document.querySelectorAll('.related-products-slider');

    console.log('[Related Products] Sliders found:', sliders.length);

    if (!sliders.length) return;

    const products = window.relatedProductRecommendation;

    console.log('[Related Products] Products:', products);

    if (!Array.isArray(products) || products.length === 0) {
      console.warn('[Related Products] No products found.');
      return;
    }

    sliders.forEach(function (slider) {
      renderRelatedProducts(slider, products);
    });
  }

  function renderRelatedProducts(slider, products) {
    slider.innerHTML = `
      <div class="related-products">

        <div class="related-products__header">
          <h3 class="related-products__title">
            Related Products
          </h3>

          <div class="related-products__controls">
            <button
              type="button"
              class="related-products__button related-products__prev"
              aria-label="Previous products">
              &#8249;
            </button>

            <button
              type="button"
              class="related-products__button related-products__next"
              aria-label="Next products">
              &#8250;
            </button>
          </div>
        </div>

        <div class="related-products__track">

          ${products.map(function (product) {
            const image = product.featured_image
              ? (product.featured_image.startsWith('//')
                  ? 'https:' + product.featured_image
                  : product.featured_image)
              : '';

            return `
              <a
                href="/products/${product.handle}"
                class="related-product">

                <div class="related-product__image-wrapper">
                  <img
                    src="${image}"
                    alt="${escapeHtml(product.title)}"
                    class="related-product__image"
                    loading="lazy">
                </div>

                <div class="related-product__info">
                  <h4 class="related-product__title">
                    ${escapeHtml(product.title)}
                  </h4>

                  <span class="related-product__price">
                    ₹${(product.price / 100).toLocaleString('en-IN')}
                  </span>
                </div>

              </a>
            `;
          }).join('')}

        </div>

      </div>
    `;

    initializeSlider(slider);
  }

  function initializeSlider(slider) {
    const track = slider.querySelector('.related-products__track');
    const previousButton = slider.querySelector('.related-products__prev');
    const nextButton = slider.querySelector('.related-products__next');

    if (!track) return;

    previousButton?.addEventListener('click', function () {
      track.scrollBy({
        left: -track.clientWidth * 0.8,
        behavior: 'smooth'
      });
    });

    nextButton?.addEventListener('click', function () {
      track.scrollBy({
        left: track.clientWidth * 0.8,
        behavior: 'smooth'
      });
    });
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedProducts);
  } else {
    initRelatedProducts();
  }
